export const getSampleRate = (value: number): number => {
  if (process.env.SENTRY_ENVIRONMENT !== 'production') {
    console.log(`Overwriting Sentry sample rate from ${value} to 1.0`);
    return 1.0;
  }
  return value;
};
